module.exports = __webpack_public_path__ + "iconaBOTTINO.svg?fee87a07d81a42185ada1a2038e43af5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconaBOTTINO.svg
// module id = 796
// module chunks = 0